<template>
  <div class="text-container">
    <transition  name="slide" mode="out-in">
      <p class="text" :key="`${text.val}${Math.random()}`">{{text.val}}</p>
    </transition>
  </div>
</template>
<script>
import * as api from '@/api';
import { 
  getActcode
} from "@/public/util.js";

const totalDuration = 2000;
export default {
  name: 'barrage',
  data () {
    return {
      tenHitRdList: [],
      sQJoinCount:0,
      number: -1,
      show:false
    }
  },
  computed: {
    text() {
      let obj = this.tenHitRdList[this.number];
      let val = ""
      if(obj){
        let {
          rewardDesc,
          rewardAmount,
          pin,
          rewardName
        } = obj;
        val = `${pin}领到 ${rewardName}${rewardAmount}`;
      }

      return {
        val: val,
        id:val
      }
    }
  },
  mounted () {
    this.requestData();
  },
  watch: {
  },
  methods: {
    requestData(){
      api.getLastHitRdListAndTotal({
        reqData: JSON.stringify({
          actCode:getActcode()
        })
      }).then(res => {
        if(res.resultCode == -1){
          this.$parent.$parent.showApiErrorPop();
        }else if(res.resultCode == 3){
          this.$parent.$parent.showNotLoginPop();
        }else{
          if(res.resultData.code == "sucess"){
            let resData = res.resultData.data;
            this.tenHitRdList = resData.tenHitRdList;
            this.sQJoinCount = resData.sQJoinCount;
            this.tenHitRdList.length > 0 && this.startMove();
          }
        }
      })
    },
    startMove(){
      let timer = setTimeout(() => {
        if (this.number >= this.tenHitRdList.length - 1) {
          this.number = 0;
        } else {
          this.number ++;
        }
        this.startMove();
      }, totalDuration)
    }
  }




}
</script>
<style lang="scss" scoped>
.text-container {
  min-width:390px;
  height:50px;
  line-height: 50px;
  background:rgba(3,0,45,0.7);
  border-radius:0px 50px 50px 0px;
  padding: 0 25px 0 20px;
  .text{
    font-size: 22px;
    color: #FFFDEB;
  }
}
.slide-enter-active, .slide-leave-active {
  transition: all 0.5s linear;
}
.slide-enter {
  opacity: 0;
  transform: translateY(10px);
}
.slide-leave-to {
  opacity: 0;
  transform: translateY(-15px);
}
</style>


// WEBPACK FOOTER //
// src/components/Barrage/index.vue